import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../queryKeys";
import { cdPostForFiles } from "../api";
import { useState } from "react";

// Define your payload interface
export interface IWireContractUploadPayload {
    file: File;
    email?: string;
}

export const useWireContractUploadSubmit = () => {
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationKey: [queryKeys.wireContractUpload, "upload file"],
        mutationFn: (payload: IWireContractUploadPayload) => uploadWireContractFile(payload),
        onSuccess: () => {
            setUploadSuccess(true);
            queryClient.invalidateQueries({ queryKey: [queryKeys.wireContractUpload, "upload file"] });
            queryClient.invalidateQueries({ queryKey: [queryKeys.wireContractUpload, "filters"] });
        },
        onError: (error: any) => {
            setErrorMessage(error?.response?.data?.data ?? error.message);
        },
    });

    return {
        mutate: mutation.mutate,
        isSuccess: mutation.isSuccess,
        isError: mutation.isError,
        error: mutation.error,
        data: mutation.data,
        uploadSuccess,
        setUploadSuccess,
        errorMessage,
        setErrorMessage,
    };
};

const uploadWireContractFile = async (payload: IWireContractUploadPayload) => {
    let qParams = new URLSearchParams();
    if (payload?.email) {
        qParams.append("email", payload.email);
    }
    if (payload?.file) {
        const fileData = await payload.file.arrayBuffer();
        const res = cdPostForFiles(`/uploadWireContracts?${qParams.toString()}`, fileData);
        return res;
    }
};